import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { fontText, StylesIndexInjections } from 'common-react';

const badgeColor = (theme: Theme) => ({
    color: theme.color.greys[0],
    backgroundColor: theme.color.greys[80],
})

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    minWidth: 20,
    height: 20,
    '& .MuiBadge-badge': {
      ...badgeColor(theme),
      font: fontText('normal', theme.fontSize.s, 16),
      transform: 'none',
      overflow: 'hidden',
    }
  },
  badgeContent: {
    position: 'relative',
    lineHeight: 1,
  }
}), { name: 'Badge', index: StylesIndexInjections.UI_ATOMS });
